module.exports = __webpack_public_path__ + "static/media/relogio-medidor.aa5478c0.png";